<template>
  <div
    class="goods-list"
    :class="{
      'has-margin': hasMarginTop,
      'no-border': noBorder
    }"
  >
    <!-- end商品折扣优惠信息展示 -->
    <div class="itm">
      <!-- check -->
      <div class="check">
        <van-checkbox
          v-model="item.checked"
          shape="square"
          checked-color="#0F6EE9"
          :disabled="getGoodsIsDisable"
          @change="$emit('itemCheckedChanged')"
        />
      </div>
      <!-- 商品图片 -->
      <div class="gimg" @click="cleckItem(item)">
        <van-image
          :width="isAlwaysBuysCom ? 100 : 140"
          :height="isAlwaysBuysCom ? 100 : 140"
          :src="_getPic(item.Logo, true)"
          fit="contain"
        />
        <!-- 类型icon -->
        <div class="type-icon">
          <div v-if="!type" />
          <div v-else-if=" iconType.includes(type)">
            <div :class="['icon-lt','icon-lt-'+type]">
              <img :src="require(`@/assets/buycar/type-${type}.png`)" alt="">
            </div>
            <div v-if="typeCode=== 128 && item.ActivityDiscount" :class="['icon-tj']">{{ item.ActivityDiscount }} 折</div>
          </div>

          <div
            v-else
            :class="
              ['icon-bt','icon-bt-'+type]"
            :style="{'color':txtColorType.includes(type)?'#ffffff':'#111A34 ','backgroundImage':'url('+require(`@/assets/buycar/type-${type}.png`)+')'}"
          >
            <span>{{ ruleTxt }}</span>
          </div>
        </div>

        <!-- 异常状态 -->
        <div v-if="isOverdue" class="mask-error">已失效</div>
        <div v-if="item.IsSoldOut" class="mask-error">{{ getGoodsStatusText }}</div>
      </div>
      <!-- 商品info -->
      <div class="gcontent" @click="cleckItem(item)">
        <div class="gname van-ellipsis">
          <!-- 新品标签 -->
          <div v-if="!isOverdue && item.IsNewProduct" style=" margin-right: 4px; font-size: 0;">
            <img style="width: 30px;" src="@/assets/goods/new.png">
          </div>
          <!-- 商品标签 -->
          <img
            v-if="item.GoodsTags && item.GoodsTags.length"
            :src="item.GoodsTags[0].Img"
            style="margin-right: 4px; width: 32px; height: 16px;"
          >
          <div style="flex: 1; font-size: bold;" class="ellips-text">
            {{ item.OperationName || item.SkuName }}
          </div>
        </div>
        <!-- 规格 -->
        <div class="gtag van-ellipsis">规格：{{ item.Specifications }}/{{ item.Unit }}</div>

        <div v-if="item.Validity" class="gtag van-ellipsis"> 效期：{{ item.Validity }}</div>

        <!-- 最低零售价和毛利 -->
        <div
          v-if="item.IsPutaway"
          class="gtag"
          style="margin-top: 12px; color: #999999;"
        >
          最低零售 ￥{{ item.RetailPrice ? item.RetailPrice.toFixed(2) : '-' }}
          | 毛利率
          {{
            _showProductProfit(
              item.RetailPrice,
              _getProductPrice(item.ActivityPrice || '', item.PriceLimit || '')
            )
          }}%
        </div>
        <!-- 商品标签 -->
        <div v-if="!isOverdue" class="tag-list">
          <div v-for="(val,idx) in goodsTagList" :key="idx" :class="['tag-box','tag-type-'+val.type]">{{ val.txt }}</div>
          <div v-if="item.MarketControlInfo && !item.MarketControlInfo.IsOverControlTime" :class="['tag-release default-release']"> 距控销释放还剩：<span :style="{color:true?'rgba(255, 57, 57, 1)':''}">{{ item.MarketControlInfo.WillFreeControlDays }}</span> 天</div>
          <div v-if="item.MarketControlInfo && item.MarketControlInfo.IsOverControlTime" :class="['tag-release red-release']"> 已过释放期,<span :style="{color:true?'rgba(255, 57, 57, 1)':''}">{{ item.MarketControlInfo.WillLoseControlDays }}天后将失去控销权</span></div>
        </div>

      </div>
      <!-- price -->
      <div class="gprice">
        <!-- 优惠价 -->
        <div v-if="item.customNewActivePrice" class="active-price">

          折后约
          <span class="unit">
            ¥{{ item.customNewActivePrice }}
          </span>
        </div>
        <!-- 商品价格 -->
        <div>￥{{ item.ActivityPrice || item.PriceLimit }} </div>
        <!-- 商品原价 -->
        <s class="origin-price fAvenirH">¥ {{ item.Price }}</s>

        <!-- 活动结束时间提示 -->
        <div
          v-if="!isOverdue && item.TotalMilliseconds"
          class="over-time"
        >
          <span class="img-fire"> <img src="@/assets/buycar/countTime.png" alt=""> </span> 失效倒计时
          <van-count-down
            :time="item.TotalMilliseconds"
            style="display: flex;"
            @finish="finishTime"
          >
            <template #default="timeData">
              <div class="timer-box">
                {{
                  timeData.hours > 9
                    ? timeData.hours
                    : "0" + timeData.hours
                }}
              </div>
              <div class="time-f">:</div>
              <div class="timer-box">
                {{
                  timeData.minutes > 9
                    ? timeData.minutes
                    : "0" + timeData.minutes
                }}
              </div>
              <div class="time-f">:</div>
              <div class="timer-box">
                {{
                  timeData.seconds > 9
                    ? timeData.seconds
                    : "0" + timeData.seconds
                }}
              </div>
            </template>
          </van-count-down>
        </div>
      </div>
      <!-- 数量 -->
      <div class="gamount">
        <van-stepper
          :value="item.Count"
          :step="item.StepLengthNumber || 1 "
          :disabled="getGoodsIsDisable"
          :disable-minus="item.Count <= item.PurchaseNumber"
          :disable-plus=" item.MaxCount?item.Count >= item.MaxCount:item.Count >=item.Stock"
          async-change
          @focus="onFocus($event)"
          @change="(v) => $emit('onStepperChange', v, item)"
        />

      </div>
      <!-- 小计 -->
      <div class="gtotal ">
        ￥{{
          (
            (Math.round(
              (item.customNewActivePrice
                ? item.customNewActivePrice
                : item.ActivityPrice
                  ? item.ActivityPrice
                  : item.PriceLimit) * 100
            ) *
              item.Count) /
            100
          ).toFixed(2)
        }}
      </div>
      <!-- 删除操作 -->
      <div v-if="!isAlwaysBuysCom" class="gaction">
        <template v-if="item.IsSoldOut">
          <div v-if="item.ArrivalNotice" class="to-msg-btn is-get">已订阅</div>
          <div v-if="!item.ArrivalNotice" class="to-msg-btn" @click.stop="SubNotice">到货通知</div>
        </template>

        <div v-if="item.IsOutBusinessScope" class="to-msg-btn">超出经营范围</div>

        <div @click.stop="onDeleted">删除</div>
      </div>
    </div>
    <!-- 输入购买数弹框 -->
    <div v-if="showInputNum" class="inputNumber">
      <div class="inputNumber-d">
        <div class="inputNumber-amout">请输入数量：</div>
        <input
          v-model.number="valInputNum"
          class="inputNumber-input"
          placeholder="请输入数量"
        >
        <div class="inputNumber-bottons">
          <div class="input-enter" @click.stop="inputNumberEnter">确定</div>
          <div class="input-cancel" @click.stop="cancelNumber">取消</div>
        </div>
      </div>
    </div>
    <!-- 商品活动信息 -->

  </div>
</template>

<script>
import { BaseMixin } from '@/mixins/BaseMixin'
import moment from 'moment'
export default {
  name: 'BuyCarProductItem',
  mixins: [BaseMixin],
  props: {
    isZqActivity: {
      type: Boolean,
      default: false
    },
    // 用来判断在多商品满赠中是第几个商品
    ListIndex: {
      type: Number,
      default: 0
    },
    GoodsSkusIndex: {
      type: Number,
      default: 0
    },
    ActivityListIndex: {
      type: Number,
      default: 0
    },
    isAlwaysBuysCom: {
      // 是否快速下单页组件
      type: Boolean,
      default: false
    },
    hasMarginTop: {
      type: Boolean,
      default: false
    },
    isInvalid: {
      // 是否失效商品
      type: Boolean,
      default: false
    },
    isActivity: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => ({
        checked: true,
        ProductName: '测试商品'
      })
    },
    noBorder: {
      type: Boolean,
      default: false
    },
    // 活动规则
    activity: {
      type: Object,
      default: () => {}
    },
    // 是否已失效
    isOverdue: {
      type: Boolean,
      default: false
    },
    // 小类类型 (128-折扣时显示折扣标签)
    typeCode: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      typeList: [
        { val: 5, label: '特价' },
        { val: 6, label: '满减' },
        { val: 3, label: '满赠' },
        { val: 7, label: '满返' },
        { val: 4, label: '换购' },
        { val: 8, label: '秒杀' },
        { val: 9, label: '效期' }
      ],
      goodsTagList: [],
      type: null,
      // 特殊位置得标签 活动类型标记 右上角位置展示icon
      iconType: [8, 5, 9],
      // 下方字体颜色
      txtColorType: [4, 3],
      showInputNum: false,
      valInputNum: 0,
      edited: false,
      ruleTxt: '',
      url: {
        // 购物车数据变动
        addOrUpdateCart: '/api_order/ShoppingCarts/AddOrUpdateCart'
      }
    }
  },
  computed: {
    getGoodsStatusText() {
      const {
        item: { Stock }
      } = this
      if (Stock <= 0) {
        // 补货中
        return '补货中'
      }
      return ''
    },
    // 获取是否禁用checkBox
    getGoodsIsDisable() {
      return this.isInvalid
    }

  },
  watch: {
    item: {
      handler(val) {
        if (val) {
          this.goodsTagList = []
          this.type = val.ActivityCode
          val.ActivityCode ? this.goodsTagList.push({ type: 1, txt: this.getConfigType(val.ActivityCode) }) : null
          val.MedicalType ? this.goodsTagList.push({ type: 2, txt: val.MedicalType == 1 ? '甲类' : val.MedicalType == 2 ? '乙类' : '医保' }) : null
          val.CountryCode ? this.goodsTagList.push({ type: 3, txt: '国家码' }) : null
        }
      },
      deep: true,
      immediate: true
    },
    activity: {
      handler(val) {
        if (!val) {
          return
        }
        const { typeCode } = this
        const { Rules } = val

        switch (typeCode) {
          // 金额每满赠
          case 513:
            this.ruleTxt = `每满${Rules[0].Limit}元，赠【${Rules[0].ProductList[0].SkuName}】*${Rules[0].ProductList[0].Count}`
            break
          // 数量每满赠
          case 514:
            this.ruleTxt = `每满${Rules[0].Limit}个，赠【${Rules[0].ProductList[0].SkuName}】*${Rules[0].ProductList[0].Count}`
            break
          // 金额满赠
          case 257:
            this.ruleTxt = `满${Rules[0].Limit}元，赠【${Rules[0].ProductList[0].SkuName}】*${Rules[0].ProductList[0].Count}`
            break
          // 数量满赠
          case 258:
            this.ruleTxt = `满${Rules[0].Limit}个，赠【${Rules[0].ProductList[0].SkuName}】*${Rules[0].ProductList[0].Count}`
            break
          // 满减
          case 16:
            if (Rules[0].DiscountType === 1) {
              this.ruleTxt = `满${Rules[0].Limit}元，减免${Rules[0].Reduce}元`
            } else if (Rules[0].DiscountType === 2) {
              this.ruleTxt = `满${Rules[0].Limit}元，打${Rules[0].Reduce}折`
            }
            break
          // 每满减
          case 32:
            if (Rules[0].DiscountType === 1) {
              this.ruleTxt = `每满${Rules[0].Limit}元，减免${Rules[0].Reduce}元`
            } else if (Rules[0].DiscountType === 2) {
              this.ruleTxt = `每满${Rules[0].Limit}元，打${Rules[0].Reduce}折`
            }
            break
          // 满返
          case 4:
            this.ruleTxt = `满${Rules[0].Limit}元，返${Rules[0].CouponList[0].CouponMoney}优惠券*${Rules[0].CouponList[0].CouponCount}`
            break
          // 每满返
          case 8:
            this.ruleTxt = `每满${Rules[0].Limit}元，返${Rules[0].CouponList[0].CouponMoney}优惠券*${Rules[0].CouponList[0].CouponCount}`
            break
        }
      },
      deep: true,
      immediate: true
    }
  },

  mounted() {
  },
  methods: {
    moment,
    finishTime() {
      location.reload()
    },

    // 获取对应字典内容
    getConfigType(data) {
      const dataArr = this.typeList.filter(v => v.val === data)
      return dataArr.length ? dataArr[0].label : ''
    },
    // 初始加载
    async onRefresh() {
      this.init()
      this.formData.page = 0 // 初始请求分页
    //  await this.onLoad()
    },
    async init() {
      Object.assign(this.$data, this.$options.data.call(this))

      // 获取物流满包邮信息
      this.getAction(this.url.logisticsFee).then((res) => {
        this.LogisticsFee = res.LogisticsTemplate || {}
      })

      this.SubmitActivitys = []
    },
    // 跳转商品详情
    cleckItem(item) {
      const { isInvalid } = this
      if (isInvalid) {
        return
      }
      this._jump(this._getTurnUrl(12), item.GoodSkuId)
    },
    // 显示输入框
    onFocus(e) {
      this.showInputNum = true
      this.valInputNum = this.item.Count
      e.target.blur()
    },

    // 获取商品实际价格
    _getProductPrice(price1, price2) {
      if (!price1 && !price2) {
        return 0
      }
      let price = price2
      if (price1 && price1 <= price2) {
        price = price1
      }
      return price
    },
    // 到货通知
    async SubNotice() {
      const data = await this.postAction('/api_customer/CustomerCollect/Create', {
        CollectType: 3,
        CollectingBusinessId: this.item.GoodSkuId,
        CollectionPrice: this._getProductPrice(
          this.item.ActivityPrice,
          this.item.PriceLimit
        )
      })
      if (!data.IsSuccess) {
        this.$toast({ position: 'bottom', message: data.Msg })
      } else {
        if (data.Data) {
          this.$parent.syncCurrentSourceData(this.ListIndex, this.ActivityListIndex, this.GoodsSkusIndex, 'ArrivalNotice', true)
        }
      }
    },
    // 关闭输入框
    cancelNumber() {
      this.showInputNum = false
    },
    // 确认输入
    inputNumberEnter() {
      if (
        this.valInputNum > this.item.MaxCount &&
        !!this.item.MaxCount
      ) {
        this.$toast({
          position: 'bottom',
          message:
            '单笔订单限购（' + this.item.MaxCount + '）盒'
        })
        this.item.Count = this.$hys.checkLimitPerOrder(
          this.item.PurchaseNumber,
          this.item.StepLengthNumber,
          this.item.MaxCount
        )
        this.showInputNum = false
        return false
      }
      if (this.valInputNum < this.item.PurchaseNumber) {
        this.$emit('onStepperChange', this.item.PurchaseNumber, this.item)
      } else if (this.valInputNum > this.item.Stock) {
        this.$toast({ position: 'bottom', message: '不能大于最大库存！' })
        this.$emit('onStepperChange', this.item.Stock, this.item)
      } else {
        this.$emit('onStepperChange', this.valInputNum, this.item)
      }
      this.cancelNumber()
    },
    checkedChange() {
      // 判断是否全选
      if (this.getAllGoodsCheckedStatus()) {
        this.checkedAll = false
        return
      }
      this.checkedAll = true
    },
    // 点击删除
    onDeleted() {
      try {
        const { ShoppingCartId } = this.item
        this.$emit('cancelGoods', ShoppingCartId)
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.goods-list {
  position: relative;
  display: flex;
  justify-content: flex-start;
  overflow-x: hidden;
  min-height: 172px;
  color: #222222;
  flex-direction: column;

  .activity-type {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 16px 32px 16px 60px;
    border-radius: 2px;
    padding: 6px 33px 6px 12px;
    width: 1108px;
    height: 26px;
    font-size: 14px;
    color: #111A34;
    background: #FFEEEC;

    .red-num {
      color: rgba(255, 57, 57, 1);
    }

    .gray-txt {
      color: rgba(102, 111, 131, 1);
    }

    .left-txt {
      font-weight: bold;
    }

    .right-txt {
      font-size: 14px;
      color: rgba(255, 57, 57, 1);

      &:hover {
        cursor: pointer;
      }
    }
  }

  .tag-list {
    >div {
      display: inline-block;
    }

    .tag-box {
      margin-right: 2px;
      border: 1px solid #019491;
      border-radius: 2px;
      padding: 0 4px;
      height: 16px;
      font-size: 12px;
      font-weight: 400;
      color: #019491;
      line-height: 16px;
    }

    .tag-type-1 {
      border: 1px solid #FE3F3F;
      color: #FE3F3F;
    }

    .tag-type-2 {
      border: 1px solid #019491;
      color: #019491;
    }

    .tag-type-3 {
      border: 1px solid #06B266;
      color: #06B266;
    }

    .tag-release {
      border-radius: 2px;
      padding: 4px 0 4px 8px;
      width: 180px;
      height: 20px;
      font-size: 12px;
      color: #111A34;
      background: linear-gradient(294deg, rgba(249, 250, 251, 0) 0%, #F0F3F5 100%);
    }

    .red-release {
      background: linear-gradient(294deg, rgba(249, 250, 251, 0) 0%, #FFF1F0 100%);
    }
  }

  .ellips-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &.has-margin {
    margin-top: 16px;
  }

  &.no-border {
    border: none;
  }

  .itm {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    margin-bottom: 16px;

    .check {
      display: flex;
      align-items: center;
      margin-left: 20px;
    }

    .gimg {
      position: relative;
      margin-left: 20px;
      width: 140px;
      height: 140px;
      cursor: pointer;

      /deep/ img {
        background: rgba(243, 245, 248, 1);
      }

      .mask-error {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        border-radius: 50%;
        width: 100px;
        height: 100px;
        font-size: 16px;
        color: #FFFFFF;
        background: #111A34;
        opacity: .65;
        line-height: 100px;
      }
      // 右上方图片
      .icon-lt {
        position: absolute;
        top: 0;
        left: 0;
      }

      .icon-lt-8 {
        img {
          width: 34px;
          height: 34px;
        }
      }

      .icon-lt-5 {
        padding: 2px 0 0 2px;

        img {
          width: 40px;
          height: 32px;
        }
      }

      .icon-lt-9 {
        img {
          width: 46px;
          height: 46px;
        }
      }

      .type-icon {
        img {
          background-color: unset;
        }
      }

      .icon-tj {
        position: absolute;
        bottom: 0;
        left: 4px;
        border: 1px solid #FF3939;
        border-radius: 12px;
        width: 54px;
        height: 20px;
        font-size: 12px;
        text-align: center;
        color: #FF3939;
        background: rgba(255, 206, 206, .65);
      }
      //下方icon
      .icon-bt {
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        border-radius: 0 0 4px 4px;
        height: 22px;
        font-size: 12px;
        color: #FFFFFF;
        background-repeat: no-repeat;
        background-size: 100% 100%;

        span {
          display: inline-block;
          overflow: hidden;
          margin: 2px 5px auto 46px;
          width: 90px;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    // 新品名称等信息
    .gcontent {
      display: flex;
      padding-top: 17px;
      padding-left: 20px;
      // width: 376px;
      width: 300px;
      font-size: 16px;
      font-weight: 400;
      text-align: left;
      flex-direction: column;
      cursor: pointer;
      line-height: 1;

      .gname {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        font-weight: 500;
        color: #111A34;
      }

      .gtag {
        margin-bottom: 8px;
        height: 18px;
        font-size: 14px;
        font-weight: 400;
        color: #666F83;
      }
    }

    .gprice {
      padding-top: 24px;
      width: 200px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      line-height: 1;

      .active-price {
        display: inline-block;
        margin-bottom: 8px;
        border-radius: 4px;
        padding: 0 7px 0 5px;
        height: 20px;
        font-size: 12px;
        color: #FFFFFF;
        background: linear-gradient(137deg, #FF6831 0%, #F3180E 100%);
        line-height: 20px;

        .unit {
          position: relative;
          top: -2px;
          font-size: 16px;
          vertical-align: middle;
        }
      }
      // 原价
      .origin-price {
        display: block;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #858B9C;
      }
      // over time
      .over-time {
        position: relative;
        display: inline-block;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 12px auto;
        margin-top: 12px;
        border-radius: 4px;
        padding: 0 6px;
        width: 78%;
        min-width: 140px;
        height: 16px;
        font-size: 12px;
        color: #FF3939;
        background: #FFEEEC;
        line-height: 16px;

        .van-count-down {
          color: #FF3939;
        }

        &::after {
          position: absolute;
          top: -5px;
          left: 50%;
          display: block;
          border-right: 5px solid transparent;
          border-bottom: 5px solid #FFEEEC;
          border-left: 5px solid transparent;
          width: 5px;
          content: '';
          transform: translateX(-50%);
        }

        .img-fire img {
          margin-bottom: 4px;
          width: 12px;
          height: 12px;
        }
      }
    }

    .gamount {
      margin-left: 50px;
      padding-top: 16px;
      font-size: 16px;

      /deep/ .van-stepper__plus::after {
        width: 2px;
      }

      /deep/ .van-stepper__plus::before {
        height: 2px;
      }

      /deep/ .van-stepper__minus::before {
        height: 2px;
      }

      /deep/ .van-stepper__plus {
        color: rgba(65, 72, 93, 1);
      }

      /deep/ .van-stepper {
        border: 1px solid #C5CAD5;
        border-radius: 2px;

        .van-stepper__input {
          margin: 0;
          border-right: 1px solid #C5CAD5;
          border-left: 1px solid #C5CAD5;
          width: 47px;
          height: 32px;
          font-size: 14px;
          background-color: #FFFFFF;
        }
      }

      /deep/.van-stepper__minus {
        width: 35px;
        height: 32px;
        font-size: 10px;
        color: #41485D;
        background-color: #FFFFFF;
      }

      /deep/.van-stepper__plus {
        width: 35px;
        height: 32px;
        font-size: 10px;
        color: #41485D;
        background-color: #FFFFFF;
      }
    }

    .gtotal {
      padding-top: 24px;
      width: 220px;
      font-size: 16px;
      color: #222222;
      line-height: 1;
    }

    .gaction {
      padding-top: 20px;
      width: 76px;
      font-size: 14px;
      font-weight: 400;
      text-align: center;
      line-height: 22px;
      cursor: pointer;

      .to-msg-btn {
        margin-bottom: 11px;
        border-radius: 2px;
        width: 72px;
        height: 22px;
        text-align: center;
        color: #FFFFFF;
        background-color: #0F6EEA;
        line-height: 22px;

        &.is-get {
          background: #C5CAD5;
        }
      }
    }
  }
  // 商品活动容器
  .goods-active-panel {
    // position: relative;
    // padding-left: 60px;
    padding-top: 16px;
    // display: flex;
  }

  .line {
    margin: 20px 46px 7px 74px;
    height: 1px;
    background-color: rgba(242, 242, 242, .4);
  }

  .gactive {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    flex-direction: row;

    .active-tag {
      border-radius: 2px;
      padding: 3px 14px;
      color: #FFFFFF;
      background: rgba(255, 57, 57, 1);
    }

    .active-tag-txt {
      color: rgba(255, 57, 57, 1);
    }

    .active-text {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-left: 10px;
      flex-direction: row;
    }
  }
}

.checked {
  background: #F9FAFB;
}

.inputNumber {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, .7);

  &-d {
    position: absolute;
    top: 30%;
    display: flex;
    align-items: flex-start;
    margin-left: 25vw;
    border-radius: 15px;
    padding: 20px 20px 10px;
    width: 50vw;
    height: 137px;
    background-color: #FFFFFF;
    box-sizing: border-box;
    flex-direction: column;
  }

  &-amout {
    margin-bottom: 10px;
  }

  &-input {
    border: none;
    border-bottom: 1px #FF5500 solid;
    width: 100%;
  }

  &-bottons {
    margin-top: 10px;
    width: 100%;
    cursor: pointer;
  }

  .input-enter,
  .input-cancel {
    float: right;
    margin-left: 30px;
    padding: 10px 0;
    color: rgb(255, 85, 0);
  }
}

// .time-f {
//   padding: 3px;
//   color: #111A34;
// }

// .timer-box {
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   border-radius: 4px;
//   width: 26px;
//   height: 22px;
//   font-size: 16px;
//   color: #FFFFFF;
//   background: #111A34;
// }
</style>
